export default __webpack_public_path__ + "static/media/icon-top-task-sp.84f420dc.svg";